function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import Immutable from 'immutable';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import c from 'classnames';
import WebformTextField from '../WebformTextField';
import WebformNumber from '../WebformNumber';
import WebformTextArea from '../WebformTextArea';
import WebformEmail from '../WebformEmail';
import WebformEmailConfirm from '../WebformEmailConfirm';
import WebformCheckbox from '../WebformCheckbox';
import WebformCheckboxes from '../WebformCheckboxes';
import WebformTelephone from '../WebformTelephone';
import WebformDate from '../WebformDate';
import WebformRadio from '../WebformRadio';
import WebformContainer from '../WebformContainer';
import WebformFieldset from '../WebformFieldset';
import WebformWizardPage from '../WebformWizardPage';
import WebformSelect from '../WebformSelect';
import WebformActions from '../WebformActions';
import WebformAddress from '../WebformAddress';
import WebformAddressAutocomplete from '../WebformAddressAutocomplete';
import WebformDutchAddressAutocomplete from '../WebformDutchAddressAutocomplete';
import WebformFileUpload from '../WebformFileUpload';
import WebformHidden from '../WebformHidden';
import WebformCaptcha from '../WebformCaptcha';
import WebformDateTime from '../WebformDateTime';
import WebformName from '../WebformName';
import { checkIfWebformHasWizardWithButtons } from '../../../helpers';
var WebformMapper = function WebformMapper(props) {
  var entities = props.entities,
    overriddenComponents = props.overriddenComponents,
    id = props.id;
  var webformHasWizardWithButtons = checkIfWebformHasWizardWithButtons(entities);
  return entities.entrySeq().map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      entity = _ref2[1];
    var mappedEntity = new Immutable.OrderedMap(entity);
    var type = mappedEntity.get('#type');
    var visible = mappedEntity.get('#visible');
    if (!(mappedEntity.hasIn(['#states', 'visible']) || mappedEntity.hasIn(['#states', 'invisible'])) || visible) {
      if (overriddenComponents && overriddenComponents[type]) {
        var OverriddenComponent = overriddenComponents[type];
        return /*#__PURE__*/React.createElement(OverriddenComponent, _extends({}, props, {
          key: mappedEntity.get('#webform_key'),
          entity: mappedEntity
        }));
      }
      switch (type) {
        case 'textfield':
          {
            return /*#__PURE__*/React.createElement(WebformTextField, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'number':
          {
            return /*#__PURE__*/React.createElement(WebformNumber, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'textarea':
          {
            return /*#__PURE__*/React.createElement(WebformTextArea, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'email':
          {
            return /*#__PURE__*/React.createElement(WebformEmail, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'webform_email_confirm':
          {
            return /*#__PURE__*/React.createElement(WebformEmailConfirm, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'tel':
          {
            return /*#__PURE__*/React.createElement(WebformTelephone, _extends({}, props, {
              visible: visible,
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'checkbox':
          {
            return /*#__PURE__*/React.createElement(WebformCheckbox, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'webform_entity_checkboxes':
        case 'checkboxes':
          {
            return /*#__PURE__*/React.createElement(WebformCheckboxes, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'webform_checkboxes_other':
          {
            return /*#__PURE__*/React.createElement(WebformCheckboxes, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity,
              showOther: true
            }));
          }
        case 'webform_entity_radios':
        case 'radios':
          {
            return /*#__PURE__*/React.createElement(WebformRadio, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'webform_radios_other':
          {
            return /*#__PURE__*/React.createElement(WebformRadio, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity,
              showOther: true
            }));
          }
        case 'wizard_page':
        case 'webform_wizard_page':
          {
            return /*#__PURE__*/React.createElement(WebformWizardPage, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity,
              WebformMapper: WebformMapper,
              showActions: webformHasWizardWithButtons
            }));
          }
        case 'container':
          {
            return /*#__PURE__*/React.createElement(WebformContainer, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity,
              WebformMapper: WebformMapper
            }));
          }
        case 'fieldset':
          {
            return /*#__PURE__*/React.createElement(WebformFieldset, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity,
              WebformMapper: WebformMapper
            }));
          }
        case 'webform_actions':
          {
            return /*#__PURE__*/React.createElement(WebformActions, _extends({}, props, {
              key: entity.get('#webform_key'),
              entity: entity,
              webformHasWizardWithButtons: webformHasWizardWithButtons
            }));
          }
        case 'autocomplete_address':
          {
            return /*#__PURE__*/React.createElement(WebformAddressAutocomplete, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'autocomplete_dutch_address':
          {
            return /*#__PURE__*/React.createElement(WebformDutchAddressAutocomplete, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'webform_address':
          {
            return /*#__PURE__*/React.createElement(WebformAddress, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'webform_name':
          {
            return /*#__PURE__*/React.createElement(WebformName, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'date':
          {
            return /*#__PURE__*/React.createElement(WebformDate, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'datetime':
          {
            return /*#__PURE__*/React.createElement(WebformDateTime, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'managed_file':
          {
            return /*#__PURE__*/React.createElement(WebformFileUpload, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              parentId: id,
              entity: mappedEntity
            }));
          }
        case 'webform_entity_select':
        case 'select':
          {
            return /*#__PURE__*/React.createElement(WebformSelect, _extends({}, props, {
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }));
          }
        case 'markup':
        case 'processed_text':
          {
            var wrapperClassNames = c('WebformProcessedText', 'boe', mappedEntity.getIn(['#wrapper_attributes', 'class', 0], ''));
            return /*#__PURE__*/React.createElement(WysiwygField, {
              key: mappedEntity.get('#webform_key'),
              property: "schema:text",
              className: wrapperClassNames,
              html: mappedEntity.get('#text', '')
            });
          }
        case 'captcha':
          if (mappedEntity.get('#captcha_type') === 'recaptcha/reCAPTCHA') {
            return /*#__PURE__*/React.createElement(WebformCaptcha, _extends({
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }, props));
          } else {
            return /*#__PURE__*/React.createElement(React.Fragment, null, "Not supported captcha type");
          }
        case 'hidden':
          {
            return /*#__PURE__*/React.createElement(WebformHidden, _extends({
              key: mappedEntity.get('#webform_key'),
              entity: mappedEntity
            }, props));
          }
        default:
          {
            return /*#__PURE__*/React.createElement("pre", {
              key: mappedEntity.get('#webform_key')
            }, type);
          }
      }
    }
  });
};
export default WebformMapper;